module.exports = __webpack_public_path__ + "root-b33b72b3/XING-Sans-Medium-Italic-262a7a6cdf9d0543a372f4cef6b7d651.woff2";